import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { getActivities } from '../../Activity/store/actions'
import Spinner from '../../App/Components/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { useWindowDimensions } from '../../Common/Hooks/useWindowDimensions'
import { IUser } from '../../User/DataStore/IUser'
import { getUsers } from '../../User/Store/actions'

import { KnowledgeTable } from './components/KnowledgeTable'
import { StickyMenu } from './components/StickyMenu'
import { setKnowledgeList } from './Store/Actions'
import { AvatarWrapper, BackButton } from './style'
import { useGetPersonKnowledgeQuery } from './util/usePersonKnowledgeQuery'

const KnowledgeContainer = styled.div`
  position: relative;
`

const NameContainer = styled.div`
  display: flex;
  justify-content: column;
`

const AvatarContainer = styled.div`
  margin-right: 1em;
`

const AvatarImage = styled.img<{ width: number }>`
  border-radius: 75px;
  width: ${({ width }) => (width < 600 ? '50px' : '140px')};
  height: ${({ width }) => (width < 600 ? '50px' : '140px')};
`

export const Knowledge = () => {
  const path = window.location
  const currentUserUuid = path.href.substring(path.href.lastIndexOf('/') + 1)
  const { data: personKnowledgeServer, status } =
    useGetPersonKnowledgeQuery(currentUserUuid)

  const { t } = useTranslation()
  const { windowWidth } = useWindowDimensions()

  const dispatch = useAppDispatch()
  const personKnowledgeFromLocalStore = useAppSelector(
    state => state.hr.knowledgeRequests.list,
  )

  const userList = useAppSelector(state => state.users.list)
  const isUserListEmpty = userList.length === 0

  const activityList = useAppSelector(state => state.activities.activity.list)

  useEffect(() => {
    if (!activityList) {
      dispatch(getActivities())
    }
    if (isUserListEmpty) {
      dispatch(getUsers())
    }
  }, [])

  useMemo(() => {
    if (personKnowledgeServer) {
      dispatch(setKnowledgeList(personKnowledgeServer))
    }
  }, [personKnowledgeServer, dispatch])

  if (
    isUserListEmpty ||
    !activityList ||
    !personKnowledgeFromLocalStore ||
    status === 'pending'
  ) {
    return <Spinner />
  }

  const user = userList.find(
    userDetails => userDetails.uuid === currentUserUuid,
  ) as IUser

  if (status === 'error') return <p>something went wrong</p>

  return (
    <KnowledgeContainer>
      <BackButton href="/hr/persons" className="button">
        {t('Back')}
      </BackButton>
      <AvatarWrapper>
        <AvatarContainer>
          <AvatarImage
            src={`${user.avatar}&w=144&h=144&fit=crop`}
            width={windowWidth}
          />
        </AvatarContainer>
        <NameContainer>
          <h1 className={'person-name'}>
            {user.firstName} {user.lastName}
          </h1>
        </NameContainer>
      </AvatarWrapper>
      <KnowledgeTable
        userUuid={currentUserUuid}
        windowWidth={windowWidth}
        personKnowledgeFromLocalStore={personKnowledgeFromLocalStore}
        activityList={activityList}
      />
      <StickyMenu
        personKnowledgeServer={personKnowledgeServer}
        personUuid={currentUserUuid}
      />
    </KnowledgeContainer>
  )
}
